import styled from "styled-components";


export const container = styled.div`
        grid-area: first-row;
        padding: 0;
        

        .container-filter{
            display: flex;
            align-items: center;
            margin: 2rem 0;
            
            color: #ff8b00;
            label{
                font-size: 2rem;
                margin-right: 2rem;
                color: #000;
            }

            input{
                border-radius: 5px;
                border: none;
                box-shadow: 0 0 10px 1px #d8d8d8;
                width: 15rem;
                padding: 5px 0px;
                font-family: 'Poppins';
                display: flex;
                flex-direction: row-reverse;
            }

            
        }
    .chart{
        width: 100%;
        height: auto;
    }

    @media (min-width: 576px) and (max-width: 767px){
        .container-filter{
            input{
                width: 14rem;
            }
        }
    }

    @media (max-width: 767px){
        .container-filter{
            label{
                display: none;
            }
        }
    }

    
    @media (max-width: 999px){
        .container-filter{
            label{
                font-size: 1.5rem;
                margin-right: 1rem;
            }
        }
    }

`